import PropTypes from "prop-types";
import TeacherManager from "./TeacherManager";
import { editSchoolTeacher, softDeleteSchoolTeacher, submitSchoolTeacher } from "firestoreService";

const SchoolTeachers = ({ data, reload }) => (
  <TeacherManager
    label="Play school teacher"
    data={data}
    reload={reload}
    onCreate={submitSchoolTeacher}
    onUpdate={editSchoolTeacher}
    onSoftDelete={softDeleteSchoolTeacher}
  />
);

SchoolTeachers.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  reload: PropTypes.func.isRequired,
};

export default SchoolTeachers;
